export default "__VITE_ASSET__CdXLXCWF__"